import React from 'react';
import { ExternalLink } from 'lucide-react';

import './Achievements.css';
import { theme } from '../../theme/designSystem';
import { achievementData } from '../../data/achievementData';

function Achievements() {
    return (
        <section className="achievements" id="achievements">
            <div className="achievements--container">
                <div className="achievements--header">
                    <span className="eyebrow eyebrow--center">Credentials</span>
                    <h2 style={{ color: theme.primary }}>Certifications &amp; professional development</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Industry certifications from Google, the Linux Foundation, Oracle, and more.
                    </p>
                </div>

                <div className="achievements--grid">
                    {achievementData.achievements.map((achievement, index) => (
                        <a
                            key={achievement.id}
                            href={achievement.url}
                            target="_blank"
                            rel="noreferrer"
                            className="achievement--card fade-in-up"
                            style={{
                                backgroundColor: theme.cardBg,
                                borderColor: theme.border,
                                animationDelay: `${index * 0.1}s`
                            }}
                        >
                            <div className="achievement--image">
                                <img src={achievement.image} alt={achievement.title} />
                            </div>
                            <div className="achievement--content">
                                <span className="achievement--field" style={{ color: theme.accent }}>
                                    {achievement.field}
                                </span>
                                <h3 style={{ color: theme.primary }}>{achievement.title}</h3>
                                <p style={{ color: theme.textSecondary }}>{achievement.date}</p>
                            </div>
                            <div className="achievement--link" style={{ color: theme.textSecondary }}>
                                <ExternalLink size={16} />
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Achievements;
